import { productListViewHandler, productListItemClickHandler, productViewHandler, productAddToCartHandler } from "./Product";
import { cartRemoveHandler, expressPaymentViewHandler, expressPaymentClickHandler, beginCheckoutHandler, woocommErrorHandler } from "./Cart";
import { pageViewEventHandler, loginEventHandler, errorViewHandler, pageNotFoundEventHandler } from "../shared/base";
import { ghfEventsHandler } from "../shared/ghf";
import { donationWidgetLoadedEventHandler, donationAddToCartEventHandler } from "../shared/DonationWidget";
import { chosenEventsHandler } from "./Chosen";
import { checkoutAddBillingViewHandler, checkoutVpvHandler, checkoutAddPaymentHandler } from "./Checkout";
import { thankYouPurchaseHandler } from "./ThankYou";
import { myAccountEventsHandler } from "./MyAccount";
import { streamlinedAddBillingAddress, streamlinedAddPaymentInfo, streamlinedAddToCart, streamlinedRemoveToCart, streamlinedBeginCheckout, streamlinedAltPayView, streamlinedCheckoutViewItem, streamlinedBeginCheckoutAltPay, streamlinedPhotoModeration, streamlinedPhotoRetake, streamlinedPhotoUpload, streamlinedThankYouView, streamlinedPurchase, streamlinedCheckoutError } from "../shared/streamlinedCheckout";
import { photoModError, photoUploadClick } from "../shared/photoModeration";
import { internalLinkHandler } from "../shared/base";
import { dwLoadEventHandler, dwGiveNowClickHandler, monthlyUpsellClickHandler, paymentOptionsViewHandler, paymentViewHandler, billingViewHandler, receiptViewHandler, errorDonateViewHandler, errorUserEntryClickHandler } from "../shared/DonateWidget";
import '../shared/surveySparrow';
import { gravityFormsNewsletter } from "../shared/gravityForms";
(function (global) {
    // Pageview Event
    global.document.addEventListener("page_view", pageViewEventHandler);
    global.document.addEventListener("error_page_not_found", pageNotFoundEventHandler);
    // Login Event
    global.document.addEventListener("login_success", loginEventHandler);
    // Donation Widget
    global.document.addEventListener("donation_widget_loaded", donationWidgetLoadedEventHandler);
    global.document.addEventListener("donation_add_to_cart", donationAddToCartEventHandler);
    var chosenEvents = [
        "chosen_product_view",
        "chosen_add_to_cart",
        "chosen_event_ended",
        "chosen_event_not_found",
        "chosen_photo_deny",
        "virtual_page_view",
    ];
    chosenEvents.forEach(function (eventKey) {
        global.document.addEventListener(eventKey, chosenEventsHandler);
    });
    // Global header and footer
    var ghfEvents = [
        "ghf_navigation",
        "cart_set"
    ];
    ghfEvents.forEach(function (eventKey) {
        global.document.addEventListener(eventKey, ghfEventsHandler);
    });
    global.document.addEventListener("woo_error_notice", woocommErrorHandler);
    /*********************
     * Product Events
     **********************/
    global.document.addEventListener("product_list_view", productListViewHandler);
    global.document.addEventListener("product_list_item_click", productListItemClickHandler);
    global.document.addEventListener("product_detail_view", productViewHandler);
    global.document.addEventListener("product_add_to_cart", productAddToCartHandler);
    /*********************
     * Cart Events
     **********************/
    global.document.addEventListener("cart_remove_item", cartRemoveHandler);
    global.document.addEventListener("express_payment_method_view", expressPaymentViewHandler);
    global.document.addEventListener("express_payment_method_click", expressPaymentClickHandler);
    global.document.addEventListener("begin_checkout", beginCheckoutHandler);
    /**********************
     * Ecomm Checkout Page
    ************************/
    window.document.addEventListener("checkout_add_billing_view", checkoutAddBillingViewHandler);
    window.document.addEventListener("checkout_vpv", checkoutVpvHandler);
    window.document.addEventListener("checkout_add_payment", checkoutAddPaymentHandler);
    /***********************
     * Ecomm Thank You Page
    *************************/
    window.document.addEventListener("thank_you_purchase", thankYouPurchaseHandler);
    /***********************
     * My Account Events
    *************************/
    global.document.addEventListener("account_lookup", myAccountEventsHandler);
    global.document.addEventListener("create_account_vpv", myAccountEventsHandler);
    global.document.addEventListener("create_account_success", myAccountEventsHandler);
    global.document.addEventListener("create_account_error", myAccountEventsHandler);
    /***********************
     * Shared Events
    *************************/
    global.document.addEventListener("error_view", errorViewHandler);
    global.document.addEventListener("gf_newsletter_event", gravityFormsNewsletter);
    /********************************************
     * Streamlined Checkout Events
     * ******************************************/
    global.document.addEventListener("streamlined_checkout_add_to_cart", streamlinedAddToCart);
    global.document.addEventListener("streamlined_checkout_remove_from_cart", streamlinedRemoveToCart);
    global.document.addEventListener("streamlined_checkout_add_billing_address", streamlinedAddBillingAddress);
    global.document.addEventListener("streamlined_checkout_add_payment_info", streamlinedAddPaymentInfo);
    global.document.addEventListener("streamlined_checkout_begin_checkout", streamlinedBeginCheckout);
    global.document.addEventListener("streamlined_checkout_view_item", streamlinedCheckoutViewItem);
    global.document.addEventListener("streamlined_checkout_alt_pay_view", streamlinedAltPayView);
    global.document.addEventListener("streamlined_checkout_begin_checkout_alt_pay", streamlinedBeginCheckoutAltPay);
    global.document.addEventListener("streamlined_checkout_photo_moderation", streamlinedPhotoModeration);
    global.document.addEventListener("streamlined_checkout_photo_retake", streamlinedPhotoRetake);
    global.document.addEventListener("streamlined_checkout_photo_upload", streamlinedPhotoUpload);
    global.document.addEventListener("streamlined_checkout_thank_you_view", streamlinedThankYouView);
    global.document.addEventListener("streamlined_checkout_purchase", streamlinedPurchase);
    global.document.addEventListener("streamlined_checkout_error", streamlinedCheckoutError);
    /***********************
     * Photo Moderation Events
    *************************/
    global.document.addEventListener("photo_upload_click", photoUploadClick);
    global.document.addEventListener("photo_moderation_error", photoModError);
    /*******************************
     * Internal Link Tracking
     *******************************/
    global.document.addEventListener("internal_link_dl", internalLinkHandler);
    // Donate Widget
    global.document.addEventListener("donate_widget_loaded", dwLoadEventHandler);
    global.document.addEventListener("checkout_donate_widget_give_now_click", dwGiveNowClickHandler);
    global.document.addEventListener("checkout_donate_widget_monthly_upsell", monthlyUpsellClickHandler);
    global.document.addEventListener("checkout_donate_widget_payment_options_view", paymentOptionsViewHandler);
    global.document.addEventListener("checkout_donate_widget_payment_view", paymentViewHandler);
    global.document.addEventListener("checkout_donate_widget_personal_info_submit_click", billingViewHandler);
    global.document.addEventListener("donate_widget_receipt_viewed", receiptViewHandler);
    global.document.addEventListener("dw_error_view", errorDonateViewHandler);
    global.document.addEventListener("error_user_entry_click", errorUserEntryClickHandler);
})(window);
